import styled from "styled-components";
import { getColor } from "../themeHandler";

interface ModalFooterProps {
  readonly modalTheme: string;
}

export const StyledFooter = styled.div<ModalFooterProps>`
  max-width: 100%;
  padding-top: 0.6em;
  text-align: center;
  font-weight: bold;
  span {
    a {
      cursor: pointer;
      color: ${(props) => getColor(props.modalTheme, 'footerTextColor')};
    }
    a:hover {
      transition: all 0.3s ease;
      color: ${(props) => getColor(props.modalTheme, 'footerTextHoverColor')} !important;
      text-decoration: none;
    }
  }
`;

StyledFooter.defaultProps = {};
